import store from './src/store'

const ProductCatalog = () => import('./src/Catalog')

const install = function(Vue, options) {
  if (!options.store) {
    throw new Error('Please register the E-Commerce Product Catalog Plugin by passing a Vuex Store')
  }
  options.store.registerModule('productCatalog', store, { preserveState: options.store.state.productCatalog !== undefined })
  options.store.subscribe((mutation, state) => {
    if (mutation.type === 'productCatalog/SET_ACTIVE_CATALOGUE_ID') {
      options.store.dispatch('blob/load', { blobID: 'product-catalogues--'.concat(mutation.payload) })
    }
  })

  Vue.component('product-catalog', ProductCatalog)
}

export default { ProductCatalog, install }
export { ProductCatalog, install }
